"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var NoShipToHome = function NoShipToHome(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#666' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'original' : _ref$size,
      _ref$langContext = _ref.langContext,
      langContext = _ref$langContext === void 0 ? {
    translate: function translate(text) {
      return text;
    }
  } : _ref$langContext;
  var iconSize = size === 'original' ? 'width="24.6" height="24.6"' : 'width="100%"';
  var title = langContext.translate('Ship to Home Not Available Icon');
  return "\n    <svg role=\"img\" aria-label=\"".concat(title, "\" xmlns=\"http://www.w3.org/2000/svg\" ").concat(iconSize, " viewBox=\"0 0 24.6 24.6\">\n      <title>").concat(title, "</title>\n      <path\n        d=\"M4.8,16.2l-.6-.3V8.6l5.5,2.8L11,10,9.6,9.3l3.9-1.8,3.3-3.3L12.2,2.1,2.4,6.6V17l1.1.5ZM12.3,4l2.4,1.1L7.6,8.3,5.3,7.2Zm9.4,2.4.4.2V17l-9.9,4.9-4-2,1.3-1.3,1.8.9V16.8L13,15.1v4.5L20.3,16V8.6l-1.6.8ZM5.6,11.2l2.9,1.4L6.1,15l-.5-.2ZM1.4,24.6,0,23.2,23.2,0l1.4,1.4Z\"\n        style=\"fill: ").concat(color, "\"\n      />\n    </svg>\n  ");
};

var _default = NoShipToHome;
exports["default"] = _default;